<template>
  <div class="pdf-container">
    <div v-if="dataReady" id="dataReady" />
    <!--<b-button class="export" @click="exportReportToPDF" size="sm" variant="second">Export to PDF</b-button>-->
    <div id="pdf-page-1" class="pdf-page">
      <div class="logo">
        <div class="d-flex justify-content-center">
          <img
              :src="
                '/static/images/unpd/unpd_logo_white_' + lang + '.svg'
              "
              height="200"
              style="margin: 0px -45px 0 0"
          />
          <img
            :src="'./static/images/GES_Logo-White.svg'"
            height="260"
            style="margin-top: -30px;"
          />
        </div>
      </div>
      <div style="width:100%; height:15px; background-color:#00a29c"></div>
      <div class="info-company">
        <b-row>
          <b-col>
            <h3
              v-if="getBusiness.selfAssessment_general_business_companyName"
              id="companyName"
            >
              {{ getBusiness.selfAssessment_general_business_companyName }}
            </h3>
            <h4>{{ $t("label_reports_managementReport_title") }}</h4>
            <h4>{{ $t("label_reports_managementReport_subtitle") }}</h4>
            <h4>{{ $t("label_reports_date_caption") }} {{ today }}</h4>
          </b-col>
        </b-row>
      </div>
    </div>
    <template v-if="pagination">
      <div v-for="(section, index) in sections" :key="index">
        <div
          v-for="(page, indexPage) in section.pages"
          :id="'pdf-page-' + pages[index + '.' + indexPage]"
          :key="indexPage"
          class="pdf-page pdf-page-flex pillar-page"
        >
          <div class="page-number">
            {{ pages[index + "." + indexPage] }}
          </div>
          <div class="sidebar">
            <div class="top">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'../static/images/GES_Logo-White' + '.svg'"
                height="100"
              />
              <h3>{{ $t("label_reports_managementReport_title") }}</h3>
            </div>
            <div class="middle">
              <div class="employment-policies">
                <p>
                  {{ $t("label_" + section.employmentPolicies + "_title") }}
                </p>
              </div>
            </div>
            <div class="bottom">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
                height="150"
              />
            </div>
          </div>
          <div class="content">
            <card-employment-policies-management
              :employment-policies-section="section.employmentPolicies"
              :title="section.title"
              :number-of-question="page.numberOfQuestion"
              :starter-question="page.starterQuestion"
            />
          </div>
        </div>
        <div
          :id="'pdf-page-' + pages[index + '.graphics']"
          class="pdf-page pdf-page-flex pillar-page"
        >
          <div class="page-number">
            {{ pages[index + ".graphics"] }}
          </div>
          <div class="sidebar">
            <div class="top">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'../static/images/GES_Logo-White' + '.svg'"
                height="100"
              />
              <h3>{{ $t("label_reports_managementReport_title") }}</h3>
            </div>
            <div class="middle">
              <div class="employment-policies">
                <p>
                  {{ $t("label_" + section.employmentPolicies + "_title") }}
                </p>
              </div>
            </div>
            <div class="bottom">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
                height="150"
              />
            </div>
          </div>
          <div class="content-indicator">
            <div class="block">
              <div class="content-card">
                <card-indicator-info-gender-gap
                  :pillar-id="section.pillar"
                  :indicator-id="section.indicator"
                  height="100%"
                />
              </div>
              <div class="content-card">
                <card-chart-gauge
                  :pillar-id="section.pillar"
                  :indicator-id="section.indicator"
                  height="100%"
                  :alias="'gauge' + section.indicator + section.pillar + index"
                />
              </div>
            </div>
            <!--div class="block">
            <div class="content-card-double">
              <card-charts-indicator :pillar-id="section.pillar" :indicator-id="section.indicator" :alias="'chart' + section.indicator + section.pillar + index" height="340px" :max-charts="1"></card-charts-indicator>
            </div>
          </div-->
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ReportsManagementReportPdf",
  data: function () {
    return {
      
      pages: {},
      pagination: false,
      today: "",
      rendered: 0,
      dataReady: false,
      sections: [
        {
          employmentPolicies: "internalExternalCommunication",
          title:
            "label_reports_managementReport_internalExternalCommunication_lettlerhead_title",
          pillar: "COM",
          indicator: "COM1",
          pages: [
            {
              numberOfQuestion: 8,
              starterQuestion: 0,
            },
          ],
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_recruitment",
          title: "label_reports_managementReport_recruitment_lettlerhead_title",
          pillar: "RSH",
          indicator: "RSH3",
          pages: [
            {
              numberOfQuestion: 10,
              starterQuestion: 0,
            },
          ],
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_promotion",
          title: "label_reports_managementReport_promotion_lettlerhead_title",
          pillar: "PDP",
          indicator: "PDP3",
          pages: [
            {
              numberOfQuestion: 8,
              starterQuestion: 0,
            },
          ],
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_training",
          title: "label_reports_managementReport_training_lettlerhead_title",
          pillar: "PDP",
          indicator: "PDP7",
          pages: [
            {
              numberOfQuestion: 10,
              starterQuestion: 0,
            },
          ],
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_wages",
          title: "label_reports_managementReport_wages_lettlerhead_title",
          pillar: "RSH",
          indicator: "RSH4",
          pages: [
            {
              numberOfQuestion: 100,
              starterQuestion: 0,
            },
          ],
        },
        {
          employmentPolicies:
            "selfAssessment_employmentPolicies_preventionSexualHarassment",
          title:
            "label_reports_managementReport_preventionSexualHarassment_letterhead_title",
          pillar: "PH",
          indicator: "PH2",
          pages: [
            {
              numberOfQuestion: 9,
              starterQuestion: 0,
            },
            {
              numberOfQuestion: 2,
              starterQuestion: 9,
            },
          ],
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_wlbs",
          title: "label_reports_managementReport_wlbs_lettlerhead_title",
          pillar: "WLBS",
          indicator: "WLBS4",
          pages: [
            {
              numberOfQuestion: 8,
              starterQuestion: 0,
            },
            {
              numberOfQuestion: 100,
              starterQuestion: 8,
            },
          ],
        },
      ],
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters(["pillarsIds", "getBusiness", "getEmploymentPolicies"]),
  },
  created() {
    if (this.$route.params.lang) {
      this.$store.dispatch("setLangNew", this.$route.params.lang);
    }
  },
  mounted() {
    var auth = {
      data: {
        id: this.$route.params.token,
      },
    };
    var business = {
      id: this.$route.params.business,
    };
    var snapshot = {
      snapshotId: this.$route.params.snapshot,
    };

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    this.today = yyyy + "-" + mm + "-" + dd;

    this.$store.commit("authSuccess", auth);
    this.$store.commit("setBusiness", business);
    this.$store.commit("setCurrentBusiness", business);
    this.$store.commit("setAccountRole", this.$route.params.accountroleid);
    this.$store
      .dispatch("BUSINESS_GET")
      .then(() => {
        this.titleReady = true;
      })
      .catch((err) => {
        console.log(err);
      });
    this.$store.commit("setSnapshots", [snapshot]);
    this.$store
      .dispatch("SELF_ASSESSMENT_GET")
      .then(() => {
        this.$store
          .dispatch("PILLARS_GET")
          .then(() => {
            this.createPagination();
            this.$forceUpdate();
            setTimeout(() => {
              this.dataReady = true;
            }, 1000);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    createPagination() {
      const pages = {
        "0.0": 1,
      };
      let currentPage = 1;
      for (const i in this.sections) {
        for (const j in this.sections[i].pages) {
          currentPage++;
          pages[i + "." + j] = currentPage;
        }
        currentPage++;
        pages[i + ".graphics"] = currentPage;
      }
      this.pages = pages;
      this.pagination = true;
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../assets/css/variables.scss";

$pdf-width: 1170px;
$pdf-height: 658px;
$pdf-sidebar: 195px;
.pdf-container {

  .content, .content-indicator{
    margin-top: -55px;
    height: 112%;
    scale: 0.89;
  }
  .content-card{
    scale: 1.1;
    margin: 30px;
  }
  .employment-policies {
    width: 100%;
    color: #fff;
    border-radius: 10px;
    border: 2px solid #fff;
    margin: 0 auto;
    font-size: 1rem;
    font-family: $font-subtitle;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    p {
      margin: 0;
      text-align: center;
      text-transform: uppercase;
    }
  }
}
h4{
  text-align: center;
}
</style>
